import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BaseSessionService } from '../services/base-session.service';
import { PortalType, portalForRole, portalHomeForRole } from './portal-routes';

/**
 * Keeps authenticated users off login/register; redirects to their portal home.
 *
 * Exception: a login belonging to a *different* portal is let through. Portals
 * are separate accounts, so bouncing an educator who asked for the family login
 * back into the educator portal would make the other login unreachable.
 */
export const guestGuard: CanActivateFn = (route) => {
  const session = inject(BaseSessionService);
  const router = inject(Router);

  if (!session.isTokenValid()) {
    return true;
  }

  const role = session.getCurrentUser()?.role;
  const targetPortal = route.data['portal'] as PortalType | undefined;

  if (targetPortal && targetPortal !== portalForRole(role)) {
    return true;
  }

  return router.createUrlTree([portalHomeForRole(role)]);
};
